import { Controller, useFieldArray } from "react-hook-form";

import { TextInput } from "@components/v2";
import { Button } from "@components/v2/buttons/button";
import { Label } from "@components/v2/typography/label";

import { ScheduledExportHeader } from "../components/scheduled-export-form/scheduled-export-header";
import {
  DEFAULT_TIME_FRAME,
  useScheduleExportFormContext,
} from "../hooks/useScheduleExportFormContext";

import { ScheduleTimeFrameSubForm } from "./time-frame-sub-form";

export const ScheduleForm = () => {
  const scheduleExportForm = useScheduleExportFormContext();

  const scheduleType = scheduleExportForm.watch("trigger.subType");

  const {
    fields,
    append: addNewTimeFrame,
    remove: removeTimeFrame,
  } = useFieldArray({
    control: scheduleExportForm.control,
    name: "trigger.timeFrames",
  });

  if (scheduleType !== "TIME_BASED") {
    return null;
  }
  const scheduleName = scheduleExportForm.watch("trigger.scheduleName");

  return (
    <>
      <ScheduledExportHeader
        title="Schedule"
        description="Select when your export should run"
      />
      <div className="flex flex-col gap-4 mt-4">
        <Label label="Schedule name" variant={300} className="w-1/2 max-w-sm">
          <Controller
            name="trigger.scheduleName"
            control={scheduleExportForm.control}
            render={({ field }) => (
              <TextInput
                size="md"
                value={field.value ?? ""}
                onChange={field.onChange}
                placeholder="My schedule..."
              />
            )}
          />
        </Label>
        {!!scheduleName && (
          <>
            {fields.map((_, index) => (
              <ScheduleTimeFrameSubForm
                key={index}
                index={index}
                onDelete={() => removeTimeFrame(index)}
              />
            ))}
            <Button
              size="lg"
              variant="tertiary"
              onClick={() => addNewTimeFrame(DEFAULT_TIME_FRAME)}
              className="text-sm w-fit"
            >
              <i className="fa-regular fa-plus"></i> Schedule
            </Button>
          </>
        )}
      </div>
    </>
  );
};
